// header.js
class Header {
  constructor() {
    this.pageSettings = drupalSettings?.header_settings?.page_settings || {};
    this.currentScrollTop = 0;
    this.navbar = document.querySelector('.noahs-theme--header--pro');
    this.headerHeight = this.navbar ? this.navbar.offsetHeight : 0;
    this.hideOnScrollDown = this.pageSettings.hide_on_scroll_down === 'on';
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const scrollTop = window.scrollY;
    let transformValue = 'translateY(0)';

    if (this.hideOnScrollDown) {
      if (this.currentScrollTop < scrollTop && scrollTop > this.headerHeight * 2) {
        transformValue = `translateY(${-this.headerHeight}px)`;
      } else if (this.currentScrollTop > scrollTop && !(scrollTop <= this.headerHeight)) {
        transformValue = 'translateY(0)';
      }
    }

    if (this.navbar) {
      this.navbar.style.transform = transformValue; 
    }

    if (scrollTop >= this.headerHeight) {
      this.navbar?.classList.add('sticky');
    } else {
      this.navbar?.classList.remove('sticky');
    }

    this.currentScrollTop = scrollTop;
  }
}

// Exportar la clase Header para poder importarla en otro archivo
export default Header;
